"use strict";
exports.__esModule = true;
exports.chart_color_cyan_300 = {
  "name": "--pf-v5-chart-color-cyan-300",
  "value": "#009596",
  "var": "var(--pf-v5-chart-color-cyan-300, #009596)"
};
exports["default"] = exports.chart_color_cyan_300;